@if (svc.loading()) {
  <p-progress-bar mode="indeterminate" [style]="{ height: '4px' }"></p-progress-bar>
} @else {
  @if (svc.fields) {
    <div class="form-row flex-align-center">
      <label>
        {{Yii.t('app', 'Display Fields')}}
      </label>
      <div>
        <ng-select
          [items]="svc.availableFields"
          [multiple]="true"
          bindLabel="name"
          [hideSelected]="true"
          appendTo="body"
          [(ngModel)]="svc.fields"
          (change)="svc.Sync()"
          placeholder="{{Yii.t('be_forms', 'Select Field...')}}">
        </ng-select>
      </div>
    </div>
  }
}
